import React, { FunctionComponent } from 'react';
import LegacyAddToWishlist from './LegacyButton';

export interface AddToWishlistProps {
  /** The SKU of the added variation. */
  sku: string;
  /** The name of the added variation. */
  // name: string;
  /** Flag indicating if the button should render the icon and the label text or just the icon.
   *  @default true
   */
  showLabel?: boolean;
}

/**
 * This is the `AddToWishlist` button component to handle adding or removing products to or from the wishlist.
 * The button label as well as the icon will be updated depending on whether the product is on the wishlist or not.
 */
export const AddToWishlist: FunctionComponent<AddToWishlistProps> = ({
  sku,
  // name,
  showLabel = true,
}): JSX.Element => <LegacyAddToWishlist sku={sku} showLabel={showLabel} />;

export default AddToWishlist;
